import React from "react";
import PageHeader from "../../../../components/Common/PageHeader";

function GridHeader() {
  return <PageHeader title="Visualizar rota" />;
}

export default GridHeader;